import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatBC } from "@/lib/format";
import { Package, CheckCircle2, Truck, X, Clock } from "lucide-react";

const STATUS = {
  paid: { cls: "bg-yellow-500/15 text-yellow-300 border-yellow-500/40", Icon: Clock, label: "Paid · Awaiting Ship" },
  shipped: { cls: "bg-blue-500/15 text-blue-300 border-blue-500/40", Icon: Truck, label: "Shipped" },
  delivered: { cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40", Icon: CheckCircle2, label: "Delivered" },
  cancelled: { cls: "bg-[#DC2626]/15 text-[#FCA5A5] border-[#DC2626]/40", Icon: X, label: "Cancelled · Refunded" },
};

export default function MyOrders() {
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/orders/mine").then((r) => setOrders(r.data)); }, []);

  return (
    <div className="space-y-7" data-testid="orders-root">
      <div>
        <div className="text-[10px] uppercase tracking-[0.28em] text-[#FBBF24] font-bold">My Orders</div>
        <h1 className="font-display text-3xl md:text-4xl font-black tracking-tight">Storefront Order Log</h1>
      </div>

      {orders.length === 0 ? (
        <div className="glass-card p-10 text-center text-white/55" data-testid="orders-empty">
          <Package className="mx-auto text-white/30 mb-3" />No orders yet. Visit the storefront to spend your BC.
        </div>
      ) : (
        <div className="space-y-3">
          {orders.map((o) => {
            const S = STATUS[o.status] || STATUS.paid;
            return (
              <div key={o.id} className="glass-card p-4 flex flex-wrap md:flex-nowrap gap-4 items-center" data-testid={`order-row-${o.id}`}>
                <div className="w-16 h-16 rounded bg-[#0a1526] overflow-hidden flex items-center justify-center shrink-0">
                  {o.product_image ? <img src={o.product_image} alt={o.product_name} className="w-full h-full object-cover" /> : <Package className="text-white/30" />}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-display font-bold text-base">{o.product_name}</div>
                  <div className="text-xs text-white/55 mt-1">
                    Qty {o.qty} · {new Date(o.placed_at).toLocaleString()}
                    {o.tracking_reference && <span className="ml-2">· Tracking: <span className="font-mono-num text-[#FBBF24]">{o.tracking_reference}</span></span>}
                  </div>
                </div>
                <div className="font-mono-num text-lg text-[#FBBF24] shrink-0">₱{formatBC(o.total_bc)}</div>
                <span className={`inline-flex items-center gap-1 text-[11px] font-semibold border rounded-full px-2.5 py-1 ${S.cls} shrink-0`}>
                  <S.Icon size={12} /> {S.label}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
